export const reels = [
  {
    id: '1',
    title: 'Tour phòng Studio A1 - Siêu đẹp!',
    thumbnail: 'https://readdy.ai/api/search-image?query=modern%20studio%20apartment%20interior%20tour%2C%20beautiful%20minimalist%20design%2C%20bright%20lighting%2C%20cozy%20atmosphere%2C%20Vietnam%20apartment&width=400&height=700&seq=rl1&orientation=portrait',
    videoUrl: 'https://www.youtube.com/embed/mXurLrX2mfk?rel=0&modestbranding=1&autoplay=1',
    views: 12500,
    likes: 890,
    duration: '0:45',
  },
  {
    id: '2',
    title: 'Căn hộ Premium tầng 9 - View triệu đô',
    thumbnail: 'https://readdy.ai/api/search-image?query=luxury%20penthouse%20apartment%20with%20panoramic%20city%20view%2C%20high%20floor%2C%20beautiful%20skyline%2C%20premium%20interior%20design&width=400&height=700&seq=rl2&orientation=portrait',
    videoUrl: 'https://www.youtube.com/embed/VIFQn9SFXaI?rel=0&modestbranding=1&autoplay=1',
    views: 28300,
    likes: 2100,
    duration: '1:02',
  },
  {
    id: '3',
    title: 'Tiện ích tòa nhà LamPark81',
    thumbnail: 'https://readdy.ai/api/search-image?query=modern%20apartment%20building%20amenities%2C%20gym%2C%20rooftop%20garden%2C%20lobby%2C%20security%2C%20Vietnam%20residential%20building&width=400&height=700&seq=rl3&orientation=portrait',
    videoUrl: 'https://www.youtube.com/embed/PpLSiNRJp0Y?rel=0&modestbranding=1&autoplay=1',
    views: 8900,
    likes: 654,
    duration: '0:38',
  },
  {
    id: '4',
    title: 'Phòng Deluxe C3 - Nội thất cao cấp',
    thumbnail: 'https://readdy.ai/api/search-image?query=deluxe%20apartment%20room%20tour%2C%20elegant%20interior%20design%2C%20premium%20furniture%2C%20city%20view%2C%20luxury%20feel&width=400&height=700&seq=rl4&orientation=portrait',
    videoUrl: 'https://www.youtube.com/embed/RPFawgIlR8k?rel=0&modestbranding=1&autoplay=1',
    views: 15600,
    likes: 1230,
    duration: '0:52',
  },
  {
    id: '5',
    title: 'Khu vực xung quanh LamPark81',
    thumbnail: 'https://readdy.ai/api/search-image?query=Vietnam%20urban%20neighborhood%2C%20street%20view%2C%20local%20market%2C%20cafes%2C%20convenient%20location%2C%20city%20life&width=400&height=700&seq=rl5&orientation=portrait',
    videoUrl: 'https://www.youtube.com/embed/tNyRG3rHkN0?rel=0&modestbranding=1&autoplay=1',
    views: 6700,
    likes: 445,
    duration: '0:30',
  },
  {
    id: '6',
    title: 'Đánh giá thực tế từ cư dân',
    thumbnail: 'https://readdy.ai/api/search-image?query=happy%20tenant%20in%20modern%20apartment%2C%20smiling%20Vietnamese%20person%20in%20cozy%20room%2C%20real%20life%20apartment%20review&width=400&height=700&seq=rl6&orientation=portrait',
    videoUrl: 'https://www.youtube.com/embed/dkAd_jnUGm8?rel=0&modestbranding=1&autoplay=1',
    views: 19800,
    likes: 1567,
    duration: '1:15',
  },
];
